import React, { Dispatch } from "react";
import FullScreenModal from "../FullScreenModal/FullScreenModal";
import { State } from "../../state/state";
import { Action } from "../../state/action";
import "./HelpModal.css";

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  state: State;
  dispatch: Dispatch<Action>;
}

const HelpModal: React.FC<HelpModalProps> = ({
  isOpen,
  onClose,
  state,
  dispatch,
}) => {
  return (
    <FullScreenModal
      header="Progress Tips"
      isOpen={isOpen}
      onClose={onClose}
      helpURL=""
      dynamicHeight={true}
    >
      <div className="help-modal-content">
        <div className="help-modal-toggle-section">
          <label className="help-modal-toggle-label">
            <span>Animate Help Icon</span>
            <button
              className={`help-modal-toggle-button ${state.helpIconAnimated ? "on" : "off"}`}
              onClick={() =>
                dispatch({
                  type: "SET_HELP_ICON_ANIMATED",
                  helpIconAnimated: !state.helpIconAnimated,
                })
              }
            >
              {state.helpIconAnimated ? "On" : "Off"}
            </button>
          </label>
        </div>
        <div className="help-modal-section">
          <ul className="help-modal-list">
            <li>
              <strong>Increase Capacity</strong> is the most important type of
              Action to purchase
            </li>
            <li>
              You can re-arrange and toggle the visibility of both Actions and
              Bricks using their respective 'Edit' and 'Settings' buttons
            </li>
            <li>
              You will struggle with progression without purchasing Brickpacks
              and Sets in higher increments (x5, x10, x20 etc.)
            </li>
            <li>
              You can click on individual Brickpack's and Set's to reveal more
              details and stats about them
            </li>
            <li>
              Auto Collect Actions for Brickpack's are impacted by the 'Find
              percentage' for said Brickpack. Maxing out the find percentage of
              each Brickpack (using the respective 'Upgrade' Action) ensures
              said Auto Collect is rewarding full brick rewards per second
            </li>
            <li>
              Yellow Triangle Icon means that purchasing said Brick or Brickpack
              is will have no effect since the brick outcome is at max capacity.
              If every brick in a brickpack is at max capacity you won't be able
              to buy more until you spend some of them or increase max capacity.
              Set's do not have a max capacity
            </li>
          </ul>
        </div>
      </div>
    </FullScreenModal>
  );
};

export default HelpModal;
